import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = 'Map My Pay - Salary Comparison & Career Analytics',
  description = 'Discover salary insights, compare compensation packages, and make informed career decisions with Map My Pay. Access real-time salary data, job opportunities, and relocation tools.',
  keywords = 'salary comparison, compensation analytics, career insights, job search, salary data, relocation tools',
  image = '/logo512.png',
  url = window.location.href,
  type = 'website',
  author = 'Map My Pay',
  structuredData = null
}) => {
  const siteUrl = window.location.origin;
  const fullUrl = url.startsWith('http') ? url : `${siteUrl}${url}`;
  const fullImage = image.startsWith('http') ? image : `${siteUrl}${image}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content="Map My Pay" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />

      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
